module.exports = __webpack_public_path__ + "img/CTWP__Dagger.d544bbaa.png";